<template>
  <div class="page" data-name="matchpaper-self-study">
    <div class="page-content infinite-scroll-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					기출문제 풀이
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div class="list">
				<ul>
					<li class="item-content item-input">
						<div class="item-inner">
							<div class="item-title item-label">학습 과정</div>
							<div class="item-input-wrap input-dropdown-wrap">
								<select placeholder="학습과정을 선택하세요." v-model="courseId" @change="onChanageSelectBox">
									<option value="">-선택-</option>
									<template v-for="(item, i) in stageList">
										<optgroup  :key="'i'+i" :label="item.name" v-if="item.id != '-' ">
											<template v-for="(subItem, a) in courseTypeList">
												<option :key="'a'+a" :value="subItem.id" v-if="item.id == subItem.stageId">
													{{subItem.name}}
												</option>
											</template>
										</optgroup>																
									</template>
								</select>
							</div>
						</div>
					</li>
					<li class="item-content item-input">
						<div class="item-inner">
							<div class="item-title item-label">중간/기말</div>
							<div class="item-input-wrap input-dropdown-wrap">								
								<select placeholder="선택하세요." v-model="termId" @change="onChanageSelectBox">
									<option value="">-선택-</option>
									<template v-for="(item, i) in termTypeList">
										<option :key="'i'+i" :value="item.id" v-if="item.id != '-'">{{item.name}}</option>
									</template>						
								</select>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<div class="list">
				<ul>
					<template v-for="(item, i) in matchPaperList">
						<li :key="'ii' + i">
							<a href="#" class="item-link" @click="startMatchPaper(i)">
								<div class="item-content item-inner">
									<div class="item-title">
										<div class="item-header">{{item.TAG_NAME}} - {{getSubTitle(i)}}</div>
										<span>{{item.MATCHPAPER_NAME}}</span>
									</div>
									<div class="item-after">
										<span class="badge" v-if="item.STUDY_KEY > 0">
											결과보기 
										</span>

										<span class="badge color-orange" v-else>											
											문제풀이 
										</span>
									</div>
								</div>
							</a>
						</li>
					</template>
				</ul>
			</div>
			<div class="preloader infinite-scroll-preloader" style="display:none"></div>
    </div>
  </div>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	components: {

	},
  data() {
    return {
     	pageNo: 1,
			pageSize: 30,
			allowInfinite: true,
			maxPageNo: 0,
			matchPaperList: [],
			stageList: [],		
			courseTypeList: [],			
			termTypeList: [],
			courseId:"",
			termId: ""
    }
  },
  mounted() {		 
		const _this = this;		 		 
		_this.initPage();
		$(document).on('page:reinit', '.page[data-name="matchpaper-self-study"]', _this.initPage);
		$('.infinite-scroll-content').on('infinite',_this.onInfinite);	
  },
  methods: {
		
		initPage() {
			const _this = this;
			_this.pageNo = 1;						
			_this.maxPageNo  = 1;
			_this.matchPaperList = [];
			_this.stageList = [];
			_this.matchcourseTypeListPaperList = [];
			_this.termTypeList = [];
			_this.courseId = "";
			_this.termId = "";

			_this.setTypeList();
			_this.loadMatchPaperStudyList();

		},
		onChanageSelectBox() {
			const _this = this;

			_this.matchPaperList = [];
			_this.loadMatchPaperStudyList();
		},
		onInfinite() {
			const _this = this;

			if(!_this.allowInfinite) return;
			_this.allowInfinite = false;
			
			$('.infinite-scroll-preloader').show();				
			  
			setTimeout(function () {
				_this.allowInfinite = true;

				if(_this.pageNo >= _this.maxPageNo){			
					_this.$f7.infiniteScroll.destroy('.infinite-scroll-content');
					$('.infinite-scroll-preloader').remove();				
      		return;
				}			
		 		
				_this.loadMatchPaperStudyList();

			}, 1000);
		},	
		startMatchPaper(itemIndex) {
			const _this = this;
			var item = _this.matchPaperList[itemIndex];
			var url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
			var code = MODULE.Util.keyToCode(CONST.matchPaperCodePrefix, item.MATCHPAPER_KEY);

			let param = {
				code : code,
				studyKey : item.STUDY_KEY,
				studyType: CONST.studyType["mp-sdy"].id
			}

			PAGES.popPage(url,param);
		},
		getSubTitle(itemIndex) {
			const _this = this;
			var item = _this.matchPaperList[itemIndex];
			var title ="";

			title += item.YEAR +"년도 "+ CONST.semesterMap[item.SEMESTER_ID].name + " " + CONST.termMap[item.TERM_ID].name;

			return title;

		},
		setTypeList() {
			const _this = this;
			_this.stageList = Object.values(CONST.stageMap);
			_this.courseTypeList = Object.values(CONST.courseMap);
			_this.termTypeList = Object.values(CONST.termMap);
		},
    loadMatchPaperStudyList() {
			const _this = this;
			var semesterId = ""
			var gradeId = "" 
			
			if(MODULE.Util.isNotEmpty(_this.courseId)){ 
				gradeId = CONST.courseMap[_this.courseId].gradeId;
				semesterId = CONST.courseMap[_this.courseId].semesterId;
			}

			var termId = _this.termId;
			if(_this.termId == CONST.termMap["all"].id){
				termId = "";
			}

			let param = {
				pGradeId: gradeId,
				pSemesterId: semesterId,
				pTermId: termId,
				pPageNo: _this.pageNo,
				pPageSize: _this.pageSize
			}

			API.ajaxRequest({
				url: API.getMatchPaperStudyListUrl(),
				data: param
			}).then(function(data) {

				if(data.matchPaperList.length > 0) {

					for(var i = 0; i < data.matchPaperList.length; i++) {
						var item = data.matchPaperList[i];
						_this.matchPaperList.push(item);
					}

					_this.pageNo += 1;	
					_this.maxPageNo = data.totalPageCount;
				} 

				$('.infinite-scroll-preloader').hide();
			}).catch(function(code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);	
			});
		
		}
		
  }
}

</script>